import { createBlueprint as e } from "@made-people/blueprint";
const t = e({
  slots: {
    wrapper: "relative aspect-product-image bg-background-surface-1 overflow-hidden rounded-lg",
    imageWrapper: "w-full h-full relative block",
    image: "absolute inset-0 object-cover h-full w-full",
    productLink: "absolute block top-0 left-0 right-0 bottom-0 z-10",
    rightArrow: "absolute right-0 top-0 z-50",
    leftArrow: "absolute left-0 top-0 z-50",
    indicatorWrapper: "absolute bottom-2 left-0 right-0 z-20 flex justify-center gap-1",
    indicatorDot: "w-1 h-1 rounded-full bg-white/50 transition-all",
    indicatorDotActive: "bg-white w-2",
    indicatorScrollbar: "h-0.5 bg-white/30 rounded-full transition-all",
    indicatorScrollbarActive: "bg-white",
    indicatorScrollbarContainer: "relative flex w-full gap-0",
    indicatorScrollbarOverlay: "absolute inset-y-0"
  },
  variants: {
    size: {
      sm: {
        wrapper: ""
      },
      md: {
        wrapper: ""
      },
      lg: {
        wrapper: ""
      }
    },
    hoverEffect: {
      swipeable: {
        imageWrapper: "overflow-scroll flex w-full snap-x snap-mandatory overflow-x-scroll no-scrollbar",
        image: "min-w-full w-full snap-start"
      },
      changeImage: {
        imageWrapper: "",
        image: "transition-opacity duration-300 first:z-[1] opacity-0 first:opacity-100 first:group-hover:opacity-0 [&:nth-child(2)]:opacity-0 [&:nth-child(2)]:group-hover:opacity-100"
      },
      scaleImage: {
        imageWrapper: "",
        image: "transition-transform duration-300 group-hover:scale-[1.1]"
      }
    },
    rounded: {
      true: {
        wrapper: ""
      },
      false: {
        wrapper: ""
      }
    }
  },
  defaultVariants: {
    hoverEffect: "changeImage"
  }
}), a = e({
  slots: {
    wrapper: "z-20 gap-2 flex",
    badge: "inline-flex px-1.5 py-1 text-label-sm rounded-md data-[type=new]:bg-primary data-[type=sale]:bg-sale-bg data-[type=sale]:text-sale-label"
  },
  variants: {
    placeIn: {
      gallery: {
        wrapper: "absolute z-20"
      },
      details: {
        wrapper: ""
      }
    },
    position: {
      topRight: {
        wrapper: "top-0 right-0"
      },
      topLeft: {
        wrapper: "top-0 left-0"
      },
      bottomRight: {
        wrapper: "bottom-0 right-0"
      },
      bottomLeft: {
        wrapper: "bottom-0 left-0"
      }
    },
    isVisible: {
      true: {
        wrapper: "visible"
      },
      false: {
        wrapper: "hidden"
      }
    }
  },
  defaultVariants: {
    placeIn: "gallery",
    isVisible: "true",
    position: "topLeft"
  }
}), n = e({
  slots: {
    wrapper: "z-20 text-body-sm hover:cursor-pointer transition-all hover:scale-[1.1]"
  },
  variants: {}
}), r = e({
  slots: {
    detailsWrapper: "relative flex flex-col lg:flex-row justify-between pt-3 lg:pt-4 lg:px-4 gap-2 lg:gap-0",
    detailsLink: "absolute block top-0 left-0 right-0 bottom-0 z-20",
    // Product Information
    name: "text-heading-2xs lg:text-heading-xs",
    shortDescription: "text-body-sm text-text-less-emphasis-1 hidden",
    productInfoText: "text-body-sm text-text-less-emphasis-1 hidden",
    // Price
    priceWrapper: "text-body-sm font-secondary",
    price: "data-[is-discounted='true']:text-sale-price",
    priceBeforeDiscount: "line-through"
  },
  variants: {
    // layout: {
    //   default: {
    //     detailsWrapper:
    //       "grid grid-cols-4 grid-rows-[min-content_min-content] gap-y-3",
    //     name: "col-span-4 lg:col-start-1 lg:col-end-3 row-span-1",
    //     priceWrapper:
    //       "lg:col-span-1 row-start-2 col-span-4 lg:col-end-5  lg:row-span-2 flex lg:flex-col lg:items-end",
    //     shortDescription: "col-start-1 col-end-4 row-start-2 row-end-3",
    //     productInfoText: "col-start-1 col-end-4 row-start-2 row-end-3",
    //   },
    // },
    spacing: {
      true: {
        detailsWrapper: ""
      },
      false: {
        detailsWrapper: ""
      }
    },
    size: {
      lg: {
        detailsWrapper: ""
      },
      md: {
        detailsWrapper: ""
      },
      sm: {
        shortDescription: "hidden",
        productInfoText: "hidden",
        priceWrapper: "",
        priceBeforeDiscount: ""
      },
      xs: {
        detailsWrapper: "hidden"
      }
    }
  },
  defaultVariants: {
    spacing: "true",
    size: "md"
  }
}), l = e({
  slots: {
    wrapper: "z-20",
    swatches: "flex gap-1 items-center",
    swatch: "w-3.5 h-3.5 border-border-light border-solid border-2 rounded-full hover:scale-110 transition-transform data-[selected=true]:outline-neutral-400 outline-1 outline outline-transparent",
    overflow: "text-xs leading-none text-muted"
  },
  variants: {
    placeIn: {
      gallery: {
        wrapper: "z-20 absolute bottom-3 left-3 lg:bottom-6 lg:left-6"
      },
      details: {
        wrapper: "col-span-2"
      }
    },
    isVisible: {
      true: {
        wrapper: ""
      },
      false: {
        wrapper: "hidden"
      }
    }
  },
  defaultVariants: {
    isVisible: "true"
  }
}), o = e({
  slots: {
    wrapper: "group relative flex flex-col z-10"
  },
  variants: {}
}), p = {
  main: o,
  details: r.clone(),
  gallery: t.clone({
    slots: {
      ...t.styles()
    }
  }),
  swatches: l.clone()
}, c = e({
  slots: {
    base: "rounded-lg z-30",
    wrapper: "grid grid-cols-5 w-full py-1 px-1",
    size: "text-black cols-span-1 text-body-sm py-2 hover:bg-background-surface-1 rounded-md !text-center w-full"
  },
  variants: {
    showOnlyOnDesktop: {
      true: {
        base: "hidden lg:flex"
      },
      false: {
        base: ""
      }
    },
    placeIn: {
      details: {
        base: "z-30 col-span-4 bg-background-surface-1"
      },
      gallery: {
        base: "absolute bg-white flex group-hover:translate-y-0 translate-y-[calc(100%+24px)] transition-transform duration-300 left-6 right-6 bottom-6"
      }
    }
  },
  defaultVariants: {
    showOnlyOnDesktop: "true"
  }
}), d = e({
  slots: {
    wrapper: "flex flex-col gap-2 bg-page-surface col-span-4 p-3 rounded-md z-30",
    container: "relative flex justify-center overflow-hidden gap-3 items-center w-full",
    minusButton: "h-full aspect-square flex bg-black text-white p-0 shrink-0 text-center items-center justify-center rounded-full [&>svg]:fill-white [&>svg]:w-3 [&>svg]:h-3 h-8 min-w-8 h-8 min-w-8",
    plusButton: "h-full aspect-square flex bg-black text-white p-0 shrink-0 text-center items-center justify-center rounded-full [&>svg]:fill-white [&>svg]:w-3 [&>svg]:h-3 h-8 min-w-8 h-8 min-w-8",
    inputFieldWrapper: "relative h-full w-full bg-white flex justify-between items-center px-4 rounded-md",
    inputFieldIcon: "w-4 h-4 min-w-4 min-h-4",
    inputField: "w-full text-center border-none",
    numberSuffix: "h-full text-body-sm flex items-center justify-end"
  },
  variants: {}
}), g = e({
  slots: {
    wrapper: "absolute bottom-0 z-20 w-full p-1 overflow-hidden",
    container: "flex flex-wrap bg-white justify-center rounded-sm overflow-hidden p-1",
    size: "basis-[12.5%] bg-white px-2 p-1 grow rounded-sm text-center text-body-2xs hover:bg-neutral-500 hover:text-white hover:cursor-pointer",
    label: "text-body-sm opacity-20 text-center p-1"
  },
  variants: {}
}), u = e({
  slots: {
    base: ""
  },
  variants: {
    placeIn: {
      details: {
        base: "z-30 col-span-4"
      },
      gallery: {
        base: "absolute flex z-30 group-hover:translate-y-0 translate-y-[calc(100%+24px)] transition-transform duration-300 left-6 right-6 bottom-6"
      },
      galleryStatic: {
        base: "absolute flex z-30 right-4 bottom-4"
      }
    }
  }
}), f = e({
  slots: {
    base: "px-5 relative",
    baseWrapper: "",
    trigger: "z-30 absolute p-3 text-label-sm lg:hidden",
    wrapper: "w-full grid grid-cols-2 gap-x-4 gap-y-4 px-10 py-10",
    size: "col-span-1",
    sizeLabel: "",
    sizes: "col-span-2 flex gap-1.5",
    header: "col-span-2 text-center",
    heading: "text-heading-md",
    productInfo: "col-span-2 grid grid-cols-[fit-content_fit-content]",
    productImage: "col-span-1 aspect-product-image",
    productName: "col-start-2 col-end-3 text-body-sm font-medium",
    produtPriceWrapper: "flex",
    productPriceWrapper: "flex flex-col col-start-3 col-end-4 text-right row-span-2",
    productPriceBeforeDiscount: "line-through text-body-xs lg:text-body-sm text-less-emphasis-1",
    productPrice: "text-body-sm lg:text-body-lg font-medium lg:font-medium data-[is-discounted=true]:text-sale-price text-right",
    optionGroupsWrapper: "flex flex-col",
    addToCartButton: ""
  },
  variants: {
    triggerPosition: {
      "top-left": { trigger: "top-0 left-0" },
      "top-right": { trigger: "top-0 right-0" },
      "bottom-left": { trigger: "bottom-0 left-0" },
      "bottom-right": { trigger: "bottom-0 right-0" }
    },
    placeIn: {
      details: {
        base: "z-30 col-span-4 bg-background-surface-1"
      },
      gallery: {
        base: "absolute bg-white flex group-hover:translate-y-0 translate-y-[calc(100%+24px)] transition-transform duration-300 left-6 right-6 bottom-6"
      }
    }
  },
  defaultVariants: {
    triggerPosition: "bottom-right"
  }
}), s = e({
  slots: {
    wrapper: "group relative flex flex-col z-10 h-full",
    outOfStockBadge: "absolute top-1/2 left-1/2 -translate-y-1/2 -translate-x-1/2 z-10"
  },
  variants: {}
}), b = {
  main: s,
  badges: a.clone({
    slots: {
      ...a.styles(),
      wrapper: "flex justify-end items-center col-start-3 col-end-5 row-start-1 row-end-2 py-3 px-4"
    }
  }),
  details: r.clone({
    slots: {
      ...r.styles(),
      price: "z-30 absolute top-0 right-0 p-4 bg-primary",
      name: "col-start-1 flex col-end-4 row-start-1 row-end-2 text-left px-4",
      shortDescription: "col-start-1 flex col-end-4 row-start-2 row-end-3 text-xs text-textless-emphasis-1 text-center px-4",
      detailsWrapper: "grid grid-cols-4 bg-background-surface-1 rounded-lg mt-4 py-2 items-center"
    }
  }),
  gallery: t.clone({
    slots: {
      ...t.styles()
    }
  }),
  swatches: l.clone()
}, h = e({
  slots: {
    base: "flex",
    item: "flex items-start w-20 flex-col gap-2",
    label: "text-heading-2xs",
    bar: "bg-black/10 h-2 w-full rounded-lg",
    barFill: "bg-brand-secondary h-full rounded-lg",
    scoreLabel: "text-body-xs font-secondary"
  },
  variants: {}
});
export {
  d as a,
  a as b,
  g as c,
  r as d,
  u as e,
  f,
  t as g,
  b as h,
  h as p,
  c as q,
  l as s,
  p as t,
  n as w
};
//# sourceMappingURL=blueprint-c8c0059d.mjs.map
